import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { SidebarNavigationModalItemBlockConfig } from '@front-platform/content-builder';
import { sidebarNavigationModalItemBlockResolveConfig } from '@front-platform/content-builder';
import { timer } from 'rxjs';
import { Component, input } from '@angular/core';

import { ModalsService } from '@core/services/modals/modals.service';
import { AuthStoreSelector } from '@common/selectors/authentication.selector';
import { SidebarNavigationModalConfig } from '@shared/modals/sidebar-navigation-modal/sidebar-navigation-modal.component';
export interface SidebarNavigationModalItemBlockRuntimeConfig {}

export type SidebarNavigationModalItemBlockConfigInput = Partial<
  Omit<SidebarNavigationModalItemBlockConfig, keyof SidebarNavigationModalItemBlockRuntimeConfig> &
    SidebarNavigationModalItemBlockRuntimeConfig
>;
export type SidebarNavigationModalItemBlockResolvedConfig = Omit<
  SidebarNavigationModalItemBlockConfig,
  keyof SidebarNavigationModalItemBlockRuntimeConfig
> &
  Partial<SidebarNavigationModalItemBlockRuntimeConfig>;
export interface SidebarNavigationModalItemBlockContract extends ConfigComponentContract<
  SidebarNavigationModalItemBlockConfigInput,
  SidebarNavigationModalItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-sidebar-navigation-modal-item-block',
  templateUrl: './sidebar-navigation-modal-item-block.component.html',
  standalone: false,
})
export class SidebarNavigationModalItemBlockComponent implements SidebarNavigationModalItemBlockContract {
  readonly config = input<SidebarNavigationModalItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    SidebarNavigationModalItemBlockConfig,
    SidebarNavigationModalItemBlockRuntimeConfig
  >(sidebarNavigationModalItemBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string | undefined {
    return this.resolvedConfig()['title'] as unknown as string | undefined;
  }
  get path(): string | undefined {
    return this.resolvedConfig()['path'] as unknown as string | undefined;
  }
  get linkTarget(): string {
    return this.resolvedConfig()['link_target'] as unknown as string;
  }
  get icon(): string | undefined {
    return this.resolvedConfig()['icon'] as unknown as string | undefined;
  }
  get userMustBeLoggedIn(): boolean {
    return this.resolvedConfig()['user_must_be_logged_in'] as unknown as boolean;
  }

  userIsLoggedIn$ = this.authSelector.selectUserIsLoggedIn;

  constructor(
    private authSelector: AuthStoreSelector,
    private readonly modalsService: ModalsService<SidebarNavigationModalConfig>,
  ) {}

  click(): void {
    // Tiny delay to prevent page change "flash"
    timer(1).subscribe(() => {
      this.modalsService.close('sidebar-navigation-modal');
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(SidebarNavigationModalItemBlockComponent, {
  'keyAliases': {},
});
